var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g-chart',{attrs:{"type":_vm.type,"settings":_vm.settings,"data":_vm.data,"options":_vm.merged_options}})}
var staticRenderFns = []

export { render, staticRenderFns }